@if (form) {
    <span>
        <span class="separator-line block mt-[0px] mb-[20px]"></span>
        <br />
        <form [formGroup]="form" #singleInNgForm="ngForm">
            <div class="grid sm:grid-cols-4 gap-3 w-full">
                <ng-container>
                    <div class="col-span-4">
                        <mat-form-field class="w-full">
                            <mat-label>{{ 'label_system' | translate }}</mat-label>
                            <mat-select [formControlName]="'documentSystemId'" [placeholder]="'label_system' | translate">
                                @for (sys of systemsDropDown; track sys) {
                                    <mat-option [value]="sys.value">
                                        {{ sys.viewValue }}
                                    </mat-option>
                                }
                            </mat-select>
                        </mat-form-field>
                    </div>
                    @if (selectedSystem == 'Kría') {
                        <documents-add-multiple-system-kria class="col-span-4"></documents-add-multiple-system-kria>
                    }
                    @if (selectedSystem == 'Snjallari LSR') {
                        <documents-add-multiple-system-portal-lsr class="col-span-4"></documents-add-multiple-system-portal-lsr>
                    }
                </ng-container>
            </div>
        </form>
    </span>
}
